module.exports = __webpack_public_path__ + "Journal Regular.cf28a0ba32f7c9e947b5.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/fonts/Journal Regular.ttf
// module id = ../../../../../src/fonts/Journal Regular.ttf
// module chunks = styles